var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 6C0.333496 2.68629 3.01979 0 6.3335 0H36.3335C39.6472 0 42.3335 2.68629 42.3335 6V36C42.3335 39.3137 39.6472 42 36.3335 42H6.3335C3.01979 42 0.333496 39.3137 0.333496 36V6Z",
    fill: "#EEEDF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3333,
    cy: 15.5833,
    r: 4.33333,
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8335 30.75V28.5833C14.8335 26.1901 16.7736 24.25 19.1668 24.25H23.5002C25.8934 24.25 27.8335 26.1901 27.8335 28.5833V30.75",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.fc5ea256ad2e4c2a0e81f3eb4a7f3efd.svg";
export { ForwardRef as ReactComponent };